const getHiddenElementHeight = (element) => {
  return new Promise((resolve) => {
    // Clone the element to avoid modifying the original
    const clone = element.cloneNode(true);

    const wrapper = document.createElement("div");
    wrapper.style.cssText =
      "position: absolute; visibility: hidden; pointer-events: none; z-index: -1;";
    wrapper.appendChild(clone);
    element.parentElement.appendChild(wrapper);

    clone.style.height = "auto";
    clone.style.maxHeight = "none";
    clone.style.minHeight = "0";

    // Use requestAnimationFrame to wait for styles to be applied
    // This could be the cause of the issue on ios.
    requestAnimationFrame(() => {
      const height = clone.getBoundingClientRect().height;
      wrapper.remove();
      resolve(height);
    });
  });
};

const initializeMenu = () => {
  const submenus = document.querySelectorAll(".submenu");
  const expandBtns = document.querySelectorAll(".submenu-expand");

  // Show initially hidden nav menu
  // to ensure height of initial expanded element.
  // Doesn't cause flash of menu as far as I can see
  const nav = document.querySelector("#sidebar > nav");
  const originalDisplay = nav ? window.getComputedStyle(nav).display : null;
  if (nav && originalDisplay === "none") {
    nav.style.display = "block";
    nav.style.visibility = "hidden";
    nav.style.zIndex = "-1";
  }

  // Initialize all submenus
  const initPromises = [];
  expandBtns.forEach(function (expandBtn) {
    const submenuDiv = expandBtn.parentElement.nextElementSibling;
    if (submenuDiv) {
      initPromises.push(
        getHiddenElementHeight(submenuDiv).then((submenuHeight) => {
          if (!submenuDiv.parentElement.classList.contains("active")) {
            submenuDiv.style.height = "0px";
          } else {
            expandBtn.style.transform = "rotate(180deg)";
            submenuDiv.style.height = submenuHeight + "px";
          }
        })
      );

      expandBtn.addEventListener("click", function () {
        submenus.forEach(function (submenu) {
          if (submenu !== submenuDiv) {
            submenu.parentElement.classList.remove("expanded");
            submenu.style.height = "0px";
          }
        });

        expandBtns.forEach(function (btn) {
          if (btn !== expandBtn) {
            btn.style.transform = "rotate(0deg)";
          }
        });

        getHiddenElementHeight(submenuDiv).then((submenuHeight) => {
          if (submenuDiv.style.height === "0px") {
            expandBtn.style.transform = "rotate(180deg)";
            submenuDiv.parentElement.classList.add("expanded");
            submenuDiv.style.height = submenuHeight + "px";
          } else {
            expandBtn.style.transform = "rotate(0deg)";
            submenuDiv.parentElement.classList.remove("expanded");
            submenuDiv.style.height = "0px";
          }
        });
      });
    }
  });

  // Restore nav display after all submenus are initialized
  Promise.all(initPromises).then(() => {
    if (nav && originalDisplay === "none") {
      nav.style = "";
    }
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeMenu);
} else {
  initializeMenu();
}
